import { render, staticRenderFns } from "./ActivityTest.vue?vue&type=template&id=63159490&scoped=true&"
import script from "./ActivityTest.vue?vue&type=script&lang=js&"
export * from "./ActivityTest.vue?vue&type=script&lang=js&"
import style0 from "./ActivityTest.vue?vue&type=style&index=0&id=63159490&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63159490",
  null
  
)

component.options.__file = "ActivityTest.vue"
export default component.exports